import CreateOrEditSegmentModal from "@/components/share-of-voice/modals/CreateOrEditSegmentModal.tsx";
import DeleteSegmentModal from "@/components/share-of-voice/modals/DeleteSegmentModal";
import useSegmentStore from "@/store/share-of-voice/segment/segment.slice.ts";

/**
 * House all the modals and modal states here.
 */

const ShareOfVoiceModals = () => {
  const isCreateOrEditSegmentModalOpen = useSegmentStore(
    (state) => state.isCreateOrEditSegmentModalOpen,
  );
  const setIsCreateOrEditSegmentModalOpen = useSegmentStore(
    (state) => state.setIsCreateOrEditSegmentModalOpen,
  );
  const updateSegmentId = useSegmentStore((state) => state.updateSegmentId);
  const isDeleteSegmentModalOpen = useSegmentStore(
    (state) => state.isDeleteSegmentModalOpen,
  );
  const setIsDeleteSegmentModalOpen = useSegmentStore(
    (state) => state.setIsDeleteSegmentModalOpen,
  );

  return (
    <>
      <CreateOrEditSegmentModal
        isOpen={isCreateOrEditSegmentModalOpen || !!updateSegmentId}
        onClose={() => setIsCreateOrEditSegmentModalOpen(false)}
        updateSegmentId={updateSegmentId}
      />
      <DeleteSegmentModal
        isOpen={isDeleteSegmentModalOpen}
        onClose={() => setIsDeleteSegmentModalOpen(false)}
      />
    </>
  );
};
export default ShareOfVoiceModals;
